import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import useLoyaltyAutoLogin from '../../hooks/useLoyaltyAutoLogin';

/**
 * Wraps the loyalty login/register form. Renders it immediately, then after the
 * page is fully loaded checks stored tokens / cookies and redirects if still signed in.
 */
export default function LoyaltySessionGate({ children }) {
  const { t } = useTranslation();
  const { checking } = useLoyaltyAutoLogin();

  return (
    <>
      {checking && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1400,
            display: 'flex',
            justifyContent: 'center',
            pt: 1,
            pointerEvents: 'none',
          }}
        >
          <Alert
            severity="info"
            icon={<CircularProgress size={18} color="inherit" />}
            sx={{ pointerEvents: 'auto', boxShadow: 2 }}
          >
            {t('loyalty.auth.checkingSession', 'Checking your session…')}
          </Alert>
        </Box>
      )}
      {children}
    </>
  );
}
